import script from "./LaputaLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaLogin.vue?vue&type=script&setup=true&lang=js"

import "./LaputaLogin.vue?vue&type=style&index=0&id=504514e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504514e6"]])

export default __exports__